/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TicketTemplateDto } from '../../models/ticket-template-dto';

export interface TicketTemplateControllerFindById$Params {
  centerId: string;
  id: string;
}

export function ticketTemplateControllerFindById(http: HttpClient, rootUrl: string, params: TicketTemplateControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketTemplateDto>> {
  const rb = new RequestBuilder(rootUrl, ticketTemplateControllerFindById.PATH, 'get');
  if (params) {
    rb.path('centerId', params.centerId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TicketTemplateDto>;
    })
  );
}

ticketTemplateControllerFindById.PATH = '/api/ticket/{centerId}/template/{id}';
